"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _input = require("../../input");
var _PercentageToggler = _interopRequireDefault(require("./PercentageToggler"));
var _Searchable2 = _interopRequireDefault(require("./Searchable.style"));
var _InputError = _interopRequireDefault(require("../../errors/InputError"));
var _helpers = require("./helpers");
var _SearchableDropdown = _interopRequireDefault(require("./SearchableDropdown"));
var _tooltip = require("../../tooltip");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  search: '',
  isSearching: false,
  searchData: []
};
var MIN_CHAR_COUNT = 3;
var MAX_NUMBER_CHAR_COUNT = 17;
var Searchable = /*#__PURE__*/function (_React$PureComponent) {
  function Searchable(props) {
    var _this;
    _classCallCheck(this, Searchable);
    _this = _callSuper(this, Searchable, [props]);
    _defineProperty(_this, "onChangeNumeric", function (value) {
      var _this$props = _this.props,
        type = _this$props.type,
        maxLength = _this$props.maxLength;
      var numericValue = (0, _utils.safeSlice)((0, _helpers.processNumeric)(value), 0, maxLength);
      var data = (0, _helpers.getFieldPayload)({
        value: numericValue,
        type: type === _helpers.SEARCHABLE_TYPES.NUMERIC_PERCENTAGE ? _helpers.SEARCHABLE_TYPES.NUMERIC_PERCENTAGE : _helpers.SEARCHABLE_TYPES.NUMERIC_SIMPLE
      });
      _this.props.formulaChange(data);
    });
    _defineProperty(_this, "onChangeExternal", function (value) {
      var hasCustomClickAction = _this.props.hasCustomClickAction;
      _this.setState({
        search: value
      });
      if (hasCustomClickAction && value.length < MIN_CHAR_COUNT) return;
      _this.setState({
        isSearching: true
      });
      _this.search(value);
    });
    _defineProperty(_this, "onChange", function (ev) {
      var value = R.path(['target', 'value'], ev);
      var _this$props2 = _this.props,
        hasCustomClickAction = _this$props2.hasCustomClickAction,
        allowNumeric = _this$props2.allowNumeric;
      if ((0, _utils.isBlank)(value)) {
        _this.props.formulaChange((0, _helpers.getFieldPayload)({}));
        return _this.setState(_objectSpread({}, initialState));
      }
      if (allowNumeric && (0, _helpers.isNumericValue)(value) && !hasCustomClickAction) {
        _this.onChangeNumeric(value);
      } else {
        _this.onChangeExternal(value);
      }
      return ev;
    });
    _defineProperty(_this, "handlingSearchableAction", function (searchValue) {
      _this.props.searchableAction(searchValue).then(function (data) {
        _this.setState({
          searchData: data,
          isSearching: false
        });
      })["catch"](function () {
        return _this.setState({
          searchData: [],
          isSearching: false
        });
      });
    });
    _defineProperty(_this, "search", (0, _utils.debounce)(function (searchValue) {
      return _this.props.allowSearch && _this.handlingSearchableAction(searchValue);
    }, 300));
    _defineProperty(_this, "changeFieldType", function (_ref) {
      var type = _ref.type;
      var data = (0, _helpers.getFieldPayload)(_objectSpread(_objectSpread({}, _this.props), {}, {
        type: type
      }));
      _this.props.formulaChange(data);
    });
    _defineProperty(_this, "itemClick", function (item) {
      var data = (0, _helpers.getFieldPayload)(_objectSpread(_objectSpread({}, item), {}, {
        type: _helpers.SEARCHABLE_TYPES.EXTERNAL
      }));
      _this.props.formulaChange(data);
      _this.setState(data);
    });
    _defineProperty(_this, "renderActionContent", function (_ref2) {
      var isNumeric = _ref2.isNumeric;
      var _this$props3 = _this.props,
        type = _this$props3.type,
        allowSearch = _this$props3.allowSearch,
        allowPercentageToggler = _this$props3.allowPercentageToggler,
        searchLengthTrigger = _this$props3.searchLengthTrigger,
        listRenderer = _this$props3.listRenderer,
        labels = _this$props3.labels,
        isFocused = _this$props3.isFocused,
        hasCustomClickAction = _this$props3.hasCustomClickAction,
        isFullWidth = _this$props3.isFullWidth;
      var _this$state = _this.state,
        searchData = _this$state.searchData,
        search = _this$state.search,
        isSearching = _this$state.isSearching;
      if (isNumeric && allowPercentageToggler) {
        return /*#__PURE__*/_react["default"].createElement(_PercentageToggler["default"], {
          onTypeChange: _this.changeFieldType,
          type: type
        });
      }
      if (!isNumeric && allowSearch && search.length >= searchLengthTrigger) {
        return /*#__PURE__*/_react["default"].createElement(_SearchableDropdown["default"], {
          searchData: searchData,
          isSearching: isSearching,
          search: search,
          isFocused: isFocused,
          labels: labels,
          itemClick: hasCustomClickAction ? function (item) {
            return _this.props.itemClick(item);
          } : _this.itemClick,
          isFullWidth: isFullWidth
        }, listRenderer);
      }
      return null;
    });
    _this.state = _objectSpread({}, initialState);
    return _this;
  }
  _inherits(Searchable, _React$PureComponent);
  return _createClass(Searchable, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        id = _this$props4.id,
        labels = _this$props4.labels,
        error = _this$props4.error,
        isFocused = _this$props4.isFocused,
        disabled = _this$props4.disabled,
        value = _this$props4.value,
        displayName = _this$props4.displayName,
        description = _this$props4.description,
        type = _this$props4.type,
        inputType = _this$props4.inputType,
        uniqueKey = _this$props4.uniqueKey,
        hasCustomClickAction = _this$props4.hasCustomClickAction,
        isFullWidth = _this$props4.isFullWidth,
        placeholder = _this$props4.placeholder,
        clearable = _this$props4.clearable,
        searchIcon = _this$props4.searchIcon,
        onClearIcon = _this$props4.onClearIcon,
        tooltipPosition = _this$props4.tooltipPosition,
        ariaLabel = _this$props4.ariaLabel,
        component = _this$props4.component,
        maxLength = _this$props4.maxLength;
      var search = this.state.search;
      var isNumeric = (0, _helpers.isNumericType)(type);
      var InputComponent = component || _input.Input;
      return /*#__PURE__*/_react["default"].createElement(_Searchable2["default"], {
        "data-testid": "searchable-wrapper",
        "data-tip": (0, _helpers.getFieldDescription)({
          type: type,
          value: value,
          description: description
        }),
        "data-place": tooltipPosition,
        "data-for": "tip-".concat(uniqueKey || value),
        isNumeric: isNumeric,
        isFullWidth: isFullWidth,
        isFocused: isFocused,
        searchIcon: searchIcon,
        disabled: disabled,
        error: error,
        value: value
      }, !search.length && !hasCustomClickAction && /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
        id: "tip-".concat(uniqueKey || value)
      }), /*#__PURE__*/_react["default"].createElement(InputComponent, {
        id: id,
        disabled: disabled,
        value: (0, _helpers.getFieldDescription)({
          value: value,
          type: type,
          description: description,
          isFocused: isFocused,
          search: search,
          displayName: displayName
        }),
        type: isNumeric ? 'number' : inputType,
        onChange: this.onChange,
        onBlur: function onBlur() {
          _this2.setState({
            isSearching: false,
            searchData: [],
            search: ''
          });
        },
        placeholder: placeholder || labels.FORMULA_INPUT_PLACEHOLDER,
        clearable: clearable,
        iconClick: onClearIcon,
        inputAriaLabel: ariaLabel,
        maxLength: maxLength
      }), isFocused && !disabled && this.renderActionContent({
        isNumeric: isNumeric
      }), error && /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
        message: labels.RULES_BUILDER_VARIABLE_MISSING
      }));
    }
  }]);
}(_react["default"].PureComponent);
var ListRenderer = function ListRenderer(_ref3) {
  var item = _ref3.item,
    itemClick = _ref3.itemClick;
  return /*#__PURE__*/_react["default"].createElement("li", {
    key: item.description.toString()
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onMouseDown: function onMouseDown() {
      return itemClick(item);
    }
  }, item.description));
};
ListRenderer.propTypes = {
  item: _propTypes["default"].shape({
    description: _propTypes["default"].string
  }).isRequired,
  itemClick: _propTypes["default"].func.isRequired
};
Searchable.defaultProps = {
  id: '',
  allowNumeric: true,
  allowSearch: true,
  allowPercentageToggler: true,
  maxLength: MAX_NUMBER_CHAR_COUNT,
  listRenderer: ListRenderer,
  disabled: false,
  error: undefined,
  value: '',
  type: '',
  inputType: null,
  isFocused: false,
  displayName: '',
  description: '',
  uniqueKey: '',
  itemClick: _utils.noop,
  hasCustomClickAction: false,
  isFullWidth: true,
  searchLengthTrigger: 1,
  tooltipPosition: 'bottom',
  placeholder: '',
  clearable: false,
  searchIcon: '',
  onClearIcon: _utils.noop,
  ariaLabel: '',
  component: null
};
Searchable.propTypes = {
  id: _propTypes["default"].string,
  allowNumeric: _propTypes["default"].bool,
  allowSearch: _propTypes["default"].bool,
  allowPercentageToggler: _propTypes["default"].bool,
  maxLength: _propTypes["default"].number,
  listRenderer: _propTypes["default"].func,
  uniqueKey: _propTypes["default"].string,
  tooltipPosition: _propTypes["default"].oneOf(['top', 'bottom']),
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  type: _propTypes["default"].string,
  inputType: _propTypes["default"].string,
  displayName: _propTypes["default"].string,
  description: _propTypes["default"].string,
  isFocused: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  formulaChange: _propTypes["default"].func.isRequired,
  searchableAction: _propTypes["default"].func.isRequired,
  itemClick: _propTypes["default"].func,
  hasCustomClickAction: _propTypes["default"].bool,
  isFullWidth: _propTypes["default"].bool,
  searchLengthTrigger: _propTypes["default"].number,
  placeholder: _propTypes["default"].string,
  searchIcon: _propTypes["default"].string,
  /** Flag to indicate if the input should have a clearvalue action. */
  clearable: _propTypes["default"].bool,
  /** An action to perform when clicking on the icon on the clear button */
  onClearIcon: _propTypes["default"].func,
  ariaLabel: _propTypes["default"].string,
  component: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].object])
};
var _default = exports["default"] = Searchable;